import { createSelector } from 'reselect';
import MessageProfileColumns from '../../containers/MessageProfileColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.MESSAGE_PROFILE.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.MESSAGE_PROFILE.isLoading;

export const getData = ReportDefinitions.MESSAGE_PROFILE.getDataFunction();

export const getRequestParams = state =>
  state.reporting.MESSAGE_PROFILE.requestParams;

export const getColumns = createSelector(
  getData,
  getRequestParams,
  MessageProfileColumns,
);
